import PropTypes from 'prop-types';

// Components
import ReportContentPreview from '@/components/pages/reports/components/ReportContentPreview';

const ContentCell = ({ value }) => <ReportContentPreview value={value} />;

ContentCell.propTypes = {
    value: PropTypes.object
};

export default ContentCell;
